module.exports = __webpack_public_path__ + "img/aParty_042724_A.716e444c.jpg";